import React, { useEffect, useState } from 'react';
import Header from '../Components/Header';
import axios from 'axios';
import {
  PieChart, Pie, Cell, Tooltip, Legend,
  BarChart, Bar, XAxis, YAxis, CartesianGrid,
  LineChart, Line, ResponsiveContainer
} from 'recharts';
import { Link } from "react-router-dom";

const Home = () => {
  const [homedata, setHomeData] = useState({});
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [salesData, setSalesData] = useState([]);

  useEffect(() => {
    axios.post(`${API_BASE_URL}dashboard.php`)
      .then((response) => {
        if (response.data.head.code === 200) {
          setHomeData(response.data.body);
          setSalesData(response.data.body.monthly_sales); // 👈 dynamic
        } else {
          console.error("Error Fetching Data", response.data.head.msg);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      });
  }, []);

  //  const salesData = [
  //   { name: "Jan", sales: 4000 },
  //   { name: "Feb", sales: 3000 },
  //   { name: "Mar", sales: 5000 },
  //   { name: "Apr", sales: 4000 },
  // ];

  const pieData = [
    // { name: "Revenue", value:  Math.round(Number(homedata.total_revenue)/Number(homedata.total_order))/2 || 0 },
    { name: "Revenue", value: Math.abs(Number(homedata.revenue_variation)) || 0 },
    { name: "Orders", value: Number(homedata.total_order) || 0 },
    { name: "Customers", value: Number(homedata.total_customer) || 0 },
    { name: "Products", value: Number(homedata.total_product) || 0 },
  ];

  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#74def8'];

  return (
    <>
      <Header />
      <div class="page-wrapper compact-wrapper" id="pageWrapper">
        <div class="page-body-wrapper">
          <div class="page-body">
            <div class="container-fluid">
              <div className="container-fluid p-4">
                {/* Dashboard header box */}
                <div
                  className="mb-4 p-4 rounded dashboard"
                  style={{
                    background:
                      "linear-gradient(90deg, rgba(98,97,235,1) 0%, rgba(156,97,235,1) 100%)",
                    color: "white",
                    fontWeight: "600",
                    fontSize: "1.75rem",
                    boxShadow: "0 4px 8px rgb(98 97 235 / 0.3)",

                  }}
                >
                  <div>Dashboard</div>
                  <small style={{ fontWeight: "400", fontSize: "1rem" }}>
                    Real-time overview of your business
                  </small>
                </div>
                

                {/* Four boxes in a responsive row */}
                <div class="row">
                  <div class="col-sm-6 col-xxl-3 col-lg-3">
                    <Link to="/purchaselist" style={{ textDecoration: 'none', color: "#000" }}>
                      <div class="main-tiles border-5 border-0 card-hover card o-hidden">
                        <div class="custome-3-bg b-r-4 card-body">
                          <div class="media align-items-center static-top-widget">
                            <div class="media-body p-0">
                              <span class="m-0">Purchase</span>
                              <h4 class="mb-0 counter">
                                {homedata.total_purchase || 0}
                                {/* <i class="fas fa-dollar-sign"></i>: {homedata.total_purchase || 0}  */}
                                <span class="badge badge-light-primary grow">
                                  <i data-feather="trending-up"></i>8.5%
                                </span>
                              </h4>
                            </div>
                            <div class="align-self-center text-center">
                              <i class="ri-shopping-bag-line"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <div class="col-sm-6 col-xxl-3 col-lg-3">
                    <Link to="/orderlist" style={{ textDecoration: 'none', color: "#000" }}>
                      <div class="main-tiles border-5 card-hover border-0 card o-hidden">
                        <div class="custome-2-bg b-r-4 card-body">
                          <div class="media static-top-widget">
                            <div class="media-body p-0">
                              <span class="m-0">Orders</span>
                              <h4 class="mb-0 counter">
                                {homedata.total_order || 0}
                              </h4>
                            </div>
                            <div class="align-self-center text-center">
                              <i class="ri-coin-fill"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <div class="col-sm-6 col-xxl-3 col-lg-3">
                    <Link to="/products" style={{ textDecoration: 'none', color: "#000" }}>
                      <div class="main-tiles border-5 card-hover border-0 card o-hidden">
                        <div class="custome-3-bg b-r-4 card-body">
                          <div class="media static-top-widget">
                            <div class="media-body p-0">
                              <span class="m-0">Products</span>
                              <h4 class="mb-0 counter">{homedata.total_product || 0}</h4>
                            </div>
                            <div class="align-self-center text-center">
                              <i class="ri-shopping-cart-fill"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <div class="col-sm-6 col-xxl-3 col-lg-3">
                    <Link to="/customerlist" style={{ textDecoration: 'none', color: "#000" }}>
                      <div class="main-tiles border-5 card-hover border-0 card o-hidden">
                        <div class="custome-4-bg b-r-4 card-body">
                          <div class="media static-top-widget">
                            <div class="media-body p-0">
                              <span class="m-0">Customers</span>
                              <h4 class="mb-0 counter">{homedata.total_customer || 0}</h4>
                            </div>
                            <div class="align-self-center text-center">
                              <i class="ri-user-add-line"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>

                </div>
              </div>
              {/* <div class="row">

                    <div class="col-sm-6 col-xxl-3 col-lg-6">
                       <Link to="/orderlist" style={{ textDecoration: 'none',color:"#000" }}>
                        <div class="main-tiles border-5 border-0 card-hover card o-hidden">
                            <div class="custome-3-bg b-r-4 card-body">
                                <div class="media align-items-center static-top-widget">
                                    <div class="media-body p-0">
                                        <span class="m-0">Total Revenue</span>
                                        <h4 class="mb-0 counter">
                                            <i class="fas fa-dollar-sign"></i>: {homedata.total_revenue || 0} 
                                            <span class="badge badge-light-primary grow">
                                                <i data-feather="trending-up"></i>8.5%
                                            </span>
                                        </h4>
                                    </div>
                                    <div class="align-self-center text-center">
                                        <i class="ri-coin-fill"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Link>
                    </div>

                    <div class="col-sm-6 col-xxl-3 col-lg-6">
                      <Link to="/orderlist" style={{ textDecoration: 'none',color:"#000" }}>
                        <div class="main-tiles border-5 card-hover border-0 card o-hidden">
                            <div class="custome-2-bg b-r-4 card-body">
                                <div class="media static-top-widget">
                                    <div class="media-body p-0">
                                        <span class="m-0">Total Orders</span>
                                        <h4 class="mb-0 counter">
                                            {homedata.total_order || 0}
                                        </h4>
                                    </div>
                                    <div class="align-self-center text-center">
                                        <i class="ri-coin-fill"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Link>
                    </div>

                    <div class="col-sm-6 col-xxl-3 col-lg-6">
                       <Link to="/products" style={{ textDecoration: 'none',color:"#000" }}>
                        <div class="main-tiles border-5 card-hover border-0 card o-hidden">
                            <div class="custome-3-bg b-r-4 card-body">
                                <div class="media static-top-widget">
                                    <div class="media-body p-0">
                                        <span class="m-0">Total Products</span>
                                        <h4 class="mb-0 counter">{homedata.total_product || 0}</h4>
                                    </div>
                                    <div class="align-self-center text-center">
                                        <i class="ri-shopping-cart-fill"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Link>
                    </div>

                    <div class="col-sm-6 col-xxl-3 col-lg-6">
                      <Link to="/customerlist" style={{ textDecoration: 'none',color:"#000" }}>
                        <div class="main-tiles border-5 card-hover border-0 card o-hidden">
                            <div class="custome-4-bg b-r-4 card-body">
                                <div class="media static-top-widget">
                                    <div class="media-body p-0">
                                        <span class="m-0">Total Customers</span>
                                        <h4 class="mb-0 counter">{homedata.total_customer || 0}</h4>
                                    </div>
                                    <div class="align-self-center text-center">
                                        <i class="ri-user-add-line"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Link>
                    </div>

                </div> */}
              <div className="container-fluid">
                <div className="row">

                  {/* 🔵 PIE CHART */}
                  <div className="col-md-4">
                    <div className="card p-3">
                      <h5>Overview</h5>
                      <ResponsiveContainer width="100%" height={300}>
                        <PieChart>
                          <Pie
                            data={pieData}
                            dataKey="value"
                            nameKey="name"
                            outerRadius={80}
                            label
                          >
                            {pieData.map((entry, index) => (
                              <Cell key={index} fill={COLORS[index % COLORS.length]} />
                            ))}
                          </Pie>
                          <Tooltip />
                          <Legend />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                  </div>

                  {/* 🟢 BAR CHART */}
                  <div className="col-md-4">
                    <div className="card p-3">
                      <h5>Sales (Monthly)</h5>
                      <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={salesData}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="name" />
                          <YAxis />
                          <Tooltip />
                          <Bar dataKey="sales" fill="#28a745" />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </div>

                  {/* 🔴 LINE CHART */}
                  <div className="col-md-4">
                    <div className="card p-3">
                      <h5>Revenue Trend</h5>
                      <ResponsiveContainer width="100%" height={300}>
                        <LineChart data={salesData}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="name" />
                          <YAxis />
                          <Tooltip />
                          <Line type="monotone" dataKey="sales" stroke="#ff4d4f" />
                        </LineChart>
                      </ResponsiveContainer>
                    </div>
                  </div>

                </div>
              </div>
              <div className="container-fluid mt-4">
  <div className="card p-3">
    <h5>Recent Orders</h5>

    <div className="table-responsive"> {/* ✅ ADD THIS */}
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Customer Name</th>
            <th>Mobile</th>
            <th>Amount</th>
          </tr>
        </thead>

        <tbody>
          {homedata?.recent?.length > 0 ? (
            homedata.recent.map((order, index) => (
              <tr key={order.order_id}>
                <td>{index + 1}</td>
                <td>{order.billing_name}</td>
                <td>{order.billing_phonenumber}</td>
                <td>$ {order.total}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center">
                No recent orders
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

  </div>
</div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Home;
